import React, { useState, useEffect, useRef } from 'react'
import HStack from './HStack'
import VStack from './VStack'

import logo from './images/accma_logo.webp'
import { ReactComponent as MenuIcon } from './images/menu.svg'
import { ReactComponent as CloseIcon } from './images/close.svg'
import Data from './data/Data'

const theme = Data.theme

const componentStyles = {
    small: {
        items: {
            root: {
                padding: 0,
            }
        },
        item: {
            padding: '20px 10px',
            color: theme.colours.text,
            cursor: 'pointer',
            borderTop: '1px solid whitesmoke'
        }
    },
    medium: {
        items: {
            root: {
                padding: 10,
            }
        },
        item: {
            padding: 10,
            color: theme.colours.text,
            cursor: 'pointer',
        }
    },
    large: {
        items: {
            root: {
                padding: 10,
            }
        },
        item: {
            padding: 10,
            color: theme.colours.text,
            cursor: 'pointer',
        }
    },
    root: {
        display: 'flex',
        flexDirection: 'row',
        //minHeight: 80,
        //justifyContent: 'space-between',
        //alignItems: 'center',
        //padding: 10,
        width: '100%',
        zIndex: 10,
    },
    bar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        //padding: 10,
        //width: '100%',
        //zIndex: 10,
    },
    items: {
        root: {
            padding: 10,
        }
    },
    item: {
        padding: 10,
        color: theme.colours.text,
        cursor: 'pointer',
    }
}

export default function MenuBar(props) {
    const {
        size = 'large',
        height = 80,
        fixed,
        shadowStyle,
        styles = {},
        //closeCallback,
        menuSelectCallback,
    } = props

    const [showMenuItems, setShowMenuItems] = useState(false)

    const cStyles = componentStyles[size] ?? {}

    const rootStyles = {
        ...componentStyles.root,
        flexDirection: 'column',
        position: fixed ? 'fixed' : null,
        top: fixed ? 0 : null,
        boxShadow: shadowStyle,
        ...styles.root
    }
    const barStyles = {
        ...componentStyles.bar,
        fontSize: 14,
        height,
        ...styles.root
    }

    if (size === 'small') {
        return (
            <>
                <div style={rootStyles}>
                    <div style={barStyles}>
                        <div>
                            <img src={logo} alt='logo' style={{ borderRadius: 10, height: 60, cursor: 'default' }} />
                        </div>
                        {
                            showMenuItems
                                ? <CloseIcon style={{ width: 36, height: 36, fill: '#444', margin: '5px 15px', cursor: 'pointer' }}
                                    onClick={_ => setShowMenuItems(!showMenuItems)}
                                />
                                : <MenuIcon style={{ width: 36, height: 36, fill: '#444', margin: '5px 15px', cursor: 'pointer' }}
                                    onClick={_ => setShowMenuItems(!showMenuItems)}
                                />
                        }
                    </div>
                    {
                        showMenuItems &&
                        renderMenu()
                    }
                </div>
                {
                    fixed &&
                    <div style={{ height }} />
                }
            </>
        )
    }
    return (
        <>
            <div style={rootStyles}>
                <div style={barStyles}>
                    <div>
                        <img src={logo} alt='logo' style={{ borderRadius: 10, height: 60, cursor: 'default' }} />
                    </div>
                    <HStack styles={componentStyles.items}>
                        <div style={componentStyles.item}
                            onClick={_ => handleSelect('home')}
                        >
                            <span>Home</span>
                        </div>
                        {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('about')}
                            >
                                <span>About us</span>
                            </div> */}
                        <div style={componentStyles.item}
                            onClick={_ => handleSelect('practitioners')}
                        >
                            <span>Our practitioners</span>
                        </div>
                        <div style={componentStyles.item}
                            onClick={_ => handleSelect('treatments')}
                        >
                            <span>Treatments</span>
                        </div>
                        <div style={componentStyles.item}
                            onClick={_ => handleSelect('appointments')}
                        >
                            <span>Contact Us</span>
                        </div>
                        {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('media')}
                            >
                                <span>Media releases</span>
                            </div> */}
                        {/* <div style={componentStyles.item}>
                                <span>Contacts</span>
                            </div> */}
                        {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('associations')}
                            >
                                <span>Associations</span>
                            </div> */}
                    </HStack>
                </div>
            </div>
            {
                fixed &&
                <div style={{ height }} />
            }
        </>
    )

    function renderMenu() {
        return (
            <VStack styles={componentStyles[size].items}>
                <div style={componentStyles[size].item}
                    onClick={_ => handleSelect('home')}
                >
                    <span>Home</span>
                </div>
                {/* <div style={componentStyles[size].item}
                                onClick={_ => handleSelect('about')}
                            >
                                <span>About us</span>
                            </div> */}
                <div style={componentStyles[size].item}
                    onClick={_ => handleSelect('practitioners')}
                >
                    <span>Our practitioners</span>
                </div>
                <div style={componentStyles[size].item}
                    onClick={_ => handleSelect('treatments')}
                >
                    <span>Treatments</span>
                </div>
                <div style={componentStyles[size].item}
                    onClick={_ => handleSelect('appointments')}
                >
                    <span>Contact Us</span>
                </div>
                {/* <div style={componentStyles[size].item}
                                onClick={_ => handleSelect('media')}
                            >
                                <span>Media releases</span>
                            </div> */}
                {/* <div style={componentStyles[size].item}>
                                <span>Contacts</span>
                            </div> */}
                {/* <div style={componentStyles[size].item}
                                onClick={_ => handleSelect('associations')}
                            >
                                <span>Associations</span>
                            </div> */}
            </VStack>
        )
    }

    function renderMenu1() {
        return (
            <VStack styles={{ ...componentStyles.items, position: 'fixed', width: '50%' }}>
                <div style={componentStyles.item}
                    onClick={_ => handleSelect('home')}
                >
                    <span>Home</span>
                </div>
                {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('about')}
                            >
                                <span>About us</span>
                            </div> */}
                <div style={componentStyles.item}
                    onClick={_ => handleSelect('practitioners')}
                >
                    <span>Our practitioners</span>
                </div>
                <div style={componentStyles.item}
                    onClick={_ => handleSelect('treatments')}
                >
                    <span>Treatments</span>
                </div>
                <div style={componentStyles.item}
                    onClick={_ => handleSelect('appointments')}
                >
                    <span>Contact Us</span>
                </div>
                {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('media')}
                            >
                                <span>Media releases</span>
                            </div> */}
                {/* <div style={componentStyles.item}>
                                <span>Contacts</span>
                            </div> */}
                {/* <div style={componentStyles.item}
                                onClick={_ => handleSelect('associations')}
                            >
                                <span>Associations</span>
                            </div> */}
            </VStack>
        )
    }

    function handleSelect(menuName) {
        console.log(menuName)
        if (menuSelectCallback) {
            menuSelectCallback(menuName)
        }
        setShowMenuItems(false)
    }
}